import { createActions, createAction } from 'redux-actions';
export var getTeasers = createActions('GET_TEASERS').getTeasers;
export var getTeasersComplete = createAction('GET_TEASERS_COMPLETE', function (payload) { return payload; }, function (payload, headers) { return ({ headers: headers }); });
